module.exports = __webpack_public_path__ + "img/warehouse.d877e07a.png";